<template>
	<div class="mm-page-main" v-loading="loading">
		<div class="page-header">
			<div class="page-title">添加小票機</div>
			<div @click="pageback" class="page-back">
				<svg class="icon svg-icon" aria-hidden="true">
					<use xlink:href="#icon-back"></use>
				</svg>
			</div>
		</div>
		<div class="pagemain">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
				<div class="form-group">
					<div class="mm-row">
						<div class="mm-col">
							<el-form-item label="小票機SN" prop="sn">
								<el-input v-model="form.sn"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="mm-row">
						<div class="mm-col">
							<el-form-item label="打印機名稱" prop="name">
								<el-input v-model="form.name"></el-input>
							</el-form-item>
						</div>
					</div>
					<div class="mm-row">
						<el-form-item label="狀態">
							<el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
							</el-switch>
						</el-form-item>
					</div>
					<div class="mm-row">
						<el-form-item label="使用場所">
							<el-switch v-model="form.scene" active-text="門店" inactive-text="辦公室">
							</el-switch>
						</el-form-item>
					</div>
				</div>

				<div  class="form-submit">
					<el-button @click="formsubmit('form')" type="primary">提交</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				loading: false,
				
				form: {
					store_id:0,
					status: true,
					scene: true,
				},
				rules: {

					sn: [{
						required: true,
						message: '請填寫小票機sn',
					}, {
						pattern: /^[\S]+$/,
						message: '只能輸入可見字符'
					}],
					name: [{
						required: true,
						message: '請填寫小票機名稱',
					}],
				}
			};
		},
		methods: {
			
			pageback() {
				this.$router.go(-1);
			},
			
			formsubmit(form) {
				
				this.$refs[form].validate((valid) => {
					if (valid) {
						this.loading = true;
						let data = this.form;
						this.post('/api/frprint/addsave', {
							data: data
						}).then((res) => {
							this.loading = false;
							
							if (res == 'noprint') {
								this.$message({
									showClose: true,
									message: '非法sn，請重新輸入！',
									type: 'error',
									
								});
							} else if(res == 'printed'){
								this.$message({
									showClose: true,
									message: '該小票機添加過，不能重複添加！',
									type: 'error',
									
								});
							} else if(res == 'success') {
								this.$message({
									showClose: true,
									message: '添加小票機成功！',
									type: 'success',
									onClose: (() => {
									})
								});
								this.pageback();
							}else{
								this.$message({
									showClose: true,
									message: '添加小票機失敗，請重試！',
									type: 'error',
									
								});
							}

							
						}).catch((err) => {
							this.loading = false;
							console.log(err)
						});
					}
				});
			}
		},
		created() {
			let id = this.$route.params.id;
			if(id>0){
				this.form.store_id = id;
			}
		}

	};
</script>
<style scoped>
	.mm-row {
		

	}
</style>
